"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DOWNLOAD_LINK_PATH_LAST_ITEM = exports.DOWNLOAD_BUTTON = void 0;
const DOWNLOAD_LINK_PATH_LAST_ITEM = exports.DOWNLOAD_LINK_PATH_LAST_ITEM = 'GetPDF.ashx';
const DOWNLOAD_BUTTON = exports.DOWNLOAD_BUTTON = 'overview';
